import React from "react"
import { PageContent, PageTitle } from "../../components/PageContent/PageContent"
import BellringersStudentGradesView from "./BellringersStudentGradesView"
import "./index.css"

export function StudentBellringers(props) {
    let title = "Bellringers"

    return (
        <PageContent className="">
            <PageTitle title={title}></PageTitle>
            <BellringersStudentGradesView />
        </PageContent>
    )
}
